import { makeElement } from "../../../common/Utils";
import l10n from "../../L10n";
import { copyText } from "../../Utils";
import { AbsSocial } from "./AbsSocial";
import Modal from '../../../md-modal';
import { ga360 } from '../socials/GA360';

// import Toast
export class CopyText extends AbsSocial {
    name: SocialName = 'copy';
    modalToast: ReturnType<typeof Modal['uiToast']>;
    dataContents = ga360.dataContents.copy;
    dataArea = ga360.dataArea.common;

    constructor(protected ElShareItemWrap: HTMLElement, protected option: ShareOption){
        super(ElShareItemWrap, option);
        this.modalToast = Modal.uiToast();
        this.init();
    }

    addEvent(){
        this.ElBtn.addEventListener('click', async () => {
            await copyText(this.option.shareUrl);
            this.modalToast.open({
                title: l10n[this.option.langCode].successMsg,
                showCloseButton: false,
                showConfirmButton: false,
                showCancelButton: false,
                customClass: 'share-toast',
                timer: 1000,
            });
            // alert(l10n[this.option.langCode].successMsg)
        });
    }

}
